import styled from "styled-components";
import { theme } from "../../theme";

export const StyledQRListContainer = styled.div`
  padding: 0 24px;
  overflow-x: auto;
  h2 {
    margin: 0;
    font-weight: 400;
    font-size: 28px;
  }
  @media (max-width: 768px) {
    padding: 0 16px;
    h2 {
      display: none;
    }
  }
`;

export const StyledQRListTableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0;
  button {
    margin: 0 !important;
  }
  @media (max-width: 768px) {
    align-items: flex-end;
    justify-content: flex-end;
  }
`;

export const StyledCountBox = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid ${theme.textColor.secondaryGray};
  min-width: 250px;
  max-width: 250px;
  div {
    padding: 22px;
  }
  div.icon {
    border-right: 1px solid ${theme.textColor.secondaryGray};
    svg {
      width: 25px;
      height: 25px;
    }
  }
  @media (max-width: 768px) {
    min-width: 100%;
    max-width: 100%;
  }
`;

export const StyledDeleteDialogBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  p {
    text-align: left;
    margin: 0;
  }
  div.dialog-action {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    margin-top: 24px;
    gap: 24px;
    button {
      width: 100%;
    }
  }
`;
